import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { cloneDeep } from 'lodash-es';
import { NotifyService } from '@farris/ui-notify';
import { eventEditorLocale } from '../entity/locale';
@Component({
  selector: 'farris-view-model',
  templateUrl: './view-model.component.html',
  styleUrls: ['./view-model.component.css']
})
export class ViewModelComponent implements OnInit {
  /** 传入参数 */
  @Input() initialState: any;
  /** 关闭弹窗 */
  @Output() close = new EventEmitter<any>();
  /** 传递参数 */
  @Output() submit = new EventEmitter<any>();

  /** 已有方法 */
  viewModelData: any;
  /** 搜索框输入值 */
  searchValue: '';
  /** 用户选中的已有方法 */
  selectedCommand: any;
  /** 最终返回值 */
  finalValue: any;
  /** 传入的视图模型值 */
  viewModel: any;
  groupIcon = '<span class="k-icon k-i-search"></span>';
  localeId = 'zh-CHS';
  constructor(public notifySer: NotifyService) { }

  ngOnInit() {
    this.initData();
    this.getLanguageEnvironment();
  }


  /** 初始化数据 */
  initData() {
    if (this.initialState.getEventPath) {
      this.viewModel = this.initialState.getEventPath().viewModelDisplay;
      const viewModelData = this.initialState.getEventPath().actionWithPath;
      viewModelData.forEach(vmItem => {
        vmItem.sourceComponent.map.forEach(mapItem => {
          mapItem['active'] = false;
          mapItem['hide'] = false;
        });
      });
      this.viewModelData = cloneDeep(viewModelData);
    }
  }
  getLanguageEnvironment() {
    if (window) {
      if (window.top) {
        if (window.top.localStorage) {
          this.localeId = window.top.localStorage.languageCode || 'zh-CHS';
        }
      }
    }
  }

  /** 弹窗关闭事件 */
  public back() {
    this.close.emit();
  }

  /** 上传修改后的数据 */
  public uploadData() {
    this.finalValue = {
      selectedCommand: this.selectedCommand,
      viewModel: this.viewModel
    }
    this.submit.emit({ elementValue: this.finalValue });
  }

  /** 获取用户点击的视图模型方法 */
  public getViewModelCommand(value, viewModelDataItem) {
    let count = 0;
    this.viewModelData.forEach(vmItem => {
      vmItem.sourceComponent.map.forEach(mapItem => {
        if (!mapItem.command['isInvalid'] && value.controller.id == mapItem.controller.id && value.command.id == mapItem.command.id && value.event.label == mapItem.event.label && viewModelDataItem.sourceComponent.id == vmItem.sourceComponent.id) {
          value['active'] = !value['active'];
          this.selectedCommand = cloneDeep(value);
        }
        else {
          if (mapItem.command['isInvalid'] && value.controller.id == mapItem.controller.id && value.command.id == mapItem.command.id && value.event.label == mapItem.event.label && viewModelDataItem.sourceComponent.id == vmItem.sourceComponent.id) {
            count++;
            if (count == 1) {
              const info = eventEditorLocale[this.localeId].eventsEditor.methodAbandoned;
              this.notifySer['info'](info);
            }
          }
          mapItem['active'] = false;
        }
      })
    })
  }

  /** 搜索框输入值变动 */
  onSearchValueChanged(changeValue) {
    // changeValue的四种情况：
    // changeValue = ''
    // changeValue = 'bkioh'
    // changeValue :{'originalEvent':xxxxx;'value':undefined}
    // changeValue :{'originalEvent':xxxxx;'value':'dsaionf' || ''}
    if (changeValue == '') {
      this.viewModelData = this.matchCommand(changeValue.toLowerCase());
    }
    else if (changeValue['originalEvent'] && ((changeValue['value'] || changeValue['value'] == ''))) {
      this.viewModelData = this.matchCommand(changeValue['value'].toLowerCase());
    }
    else if (changeValue && !(changeValue['originalEvent'] && (changeValue['value'] == undefined))) {
      this.viewModelData = this.matchCommand(changeValue.toLowerCase());
    }
  }

  /** 搜索框清空 */
  public onClear() {
    this.matchCommand(' ');
  }

  /** 匹配满足条件的方法并显示 */
  public matchCommand(changeValue) {
    if (!changeValue['originalEvent']) {
      changeValue = changeValue.replace(/ /g, '').replace(/>/g, '')
      if (changeValue == '') {
        changeValue = ' ';
      }
      this.viewModelData.forEach(viewModelDataItem => {
        const pathString = viewModelDataItem.path;
        viewModelDataItem.sourceComponent.map.forEach(mapItem => {
          const commandString = mapItem.command.name;
          const eventString = mapItem.event.name;
          const commandLabelString = mapItem.command.label;
          let string: any = `${pathString}${commandString}${eventString}${commandLabelString}`.toLowerCase();
          if (!string.includes(changeValue)) {
            mapItem['hide'] = true;
          }
          else {
            mapItem['hide'] = false;
          }
        });
      });
    }
    return this.viewModelData;
  }

}
